module.exports = __webpack_public_path__ + "assets/7a62e78e03a1709c8726626095654bb5.jpg";